module.exports = __webpack_public_path__ + "static/media/ROPEZE_BANNER_1.2c5cb593.jpg";